const If = (props, children) => {
    if (!props.condition) {
        return null;
    }
    return children;
};

export { If as I };
